import React, { useState } from "react";
import "./index.css";
import { NavigationDesktop } from "src/components/shopify/NavigationDesktop";

export function OverLayNavigation() {
  const [hover, setHover] = useState(false);
  return (
    <div className="overlay-contain" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <div
        style={{
          height: 56,
          padding: "10px 16px",
          display: "flex",
          backgroundColor: "rgba(26, 26, 26, 1)",
          alignItems: "center",
          gap: 8,
        }}
      >
        <a href="/">
          <img alt="L192 Seller" src="/seller.svg" className="Polaris-TopBar__Logo" style={{ width: 124 }} />
        </a>
        {/* <div
          className="text-white"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setOpen(!open);
          }}
        >
          <img
            src={open ? "/assets/icons8-double-left-52.png" : "/assets/icons8-double-right-52.png"}
            style={{ width: 17 }}
            alt=""
          />
        </div> */}
      </div>
      <div className="main">{!!hover && <NavigationDesktop />}</div>
    </div>
  );
}
